module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/ielts/sections/apps/assets/flashcard_app-3ef263e6a4db2883e8b03738e46ded88.png";